import style from './style.css';

const StepTextBox = ({
  stepNumber,
  stepTextTop,
  stepTextBottom,
  currentIndex,
  isHtb,
}) => {
  return (
    <div
      className={`${style.stepTextBoxContainer} ${currentIndex ===
        stepNumber - 1 && style.highlight}`}>
      <div className={style.boxUpperDiv}>
        <div
          className={`${style.stepNumberContainer} ${isHtb &&
            style.stepNumberContainerHtb}`}>
          {stepNumber}
        </div>
        {stepNumber != '4' && <hr className={style.separator} />}
      </div>
      <div
        className={`${style.boxLowerDiv} ${currentIndex === stepNumber - 1 &&
          style.textEnlarge}`}>
        <h>
          {stepTextTop}
          <br />
          {stepTextBottom}
        </h>
      </div>
    </div>
  );
};

export default StepTextBox;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/bic-steps/steps-text/step-text-box/index.js